module.exports = __webpack_public_path__ + "img/MCO.59b54281.svg";